import { render, staticRenderFns } from "./Filiacao.vue?vue&type=template&id=7c991e26&scoped=true&"
import script from "./Filiacao.vue?vue&type=script&lang=js&"
export * from "./Filiacao.vue?vue&type=script&lang=js&"
import style0 from "./Filiacao.vue?vue&type=style&index=0&id=7c991e26&lang=scss&scoped=true&"
import style1 from "./Filiacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c991e26",
  null
  
)

export default component.exports